module.exports = "<div class=\"orderConfirmationPanel orderConfirmationPanel-scrollingContent\" ng-switch=\"$ctrl.status\">\r\n    <wow-checkout-confirmation ng-switch-when=\"ordercomfirmation\" confirmation=\"::$ctrl.confirmation\" save-card=\"::$ctrl.saveCard\"></wow-checkout-confirmation>\r\n    <wow-order-confirmation-export-options ng-switch-when=\"ordercomfirmation\" ng-if=\"!$ctrl.orderCancelled\"></wow-order-confirmation-export-options>\r\n    <wow-loading-spinner ng-switch-when=\"loading\"></wow-loading-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/order/confirmation/order-confirmation-panel.component.html
// module id = 542
// module chunks = 0